import { LESS_512_MEDIA_QUERY } from '../../../../../consts/adaptive';

export const styles = {
    '@keyframes slideTop': {
        from: {
            opacity: 0,
            transform: 'translateY(-50px)',
        },
        to: {
            opacity: 1,
            transform: 'translateY(0)',
        },
    },
    '@keyframes slideBottom': {
        from: {
            opacity: 1,
            transform: 'translateY(0)',
        },
        to: {
            opacity: 0,
            transform: 'translateY(-25px)',
        },
    },
    wrapper: {
        position: 'relative',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: 16,
        borderLeft: '2px solid #f6f6f6',
    },
    container: {
        position: 'relative',
        zIndex: 1,
        display: 'flex',
        alignItems: 'baseline',
    },
    titleWrapper: {
        marginLeft: 12,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    showDetailButton: {
        marginTop: 2,
        padding: 0,
        fontWeight: 600,
        fontSize: '10px',
        textTransform: 'uppercase',
        color: '#3d95fb',
        border: 'none',
        background: 'none',
        cursor: 'pointer',

        ['&:hover']: {
            color: '#2087ff',
        },
    },
    title: {
        margin: 0,
        fontSize: '20px',
        lineHeight: '27px',
        color: '#313140',
        fontStyle: 'normal',
        fontWeight: 700,
    },
    detailWrapper: {
        animation: 'slideTop 0.2s ease-in-out',
        animationFillMode: 'forwards',
    },
    detailWrapperCloseAnimation: {
        animation: 'slideBottom 0.15s ease-out',
        animationFillMode: 'forwards',
    },
    [LESS_512_MEDIA_QUERY]: {
        title: {
            fontSize: '18px',
            wordBreak: 'break-word'
        },
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
